const HorizLine = () => {
  return (
    <hr style={{
      margin: '64px auto',
    }}/>
  );
};

export default HorizLine;